import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const Toast: React.FC<ToastProps> = ({ visible, setVisible, children, duration =3000, isControled = false }) => {

    useEffect(() => {
        if (!isControled) {
            const timer = setTimeout(() => {
                setVisible(false);
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [duration]);

    if (!visible) return null;

    return <ToastContainer>{children}</ToastContainer>;
};

export default Toast;


interface ToastProps {
    visible: boolean,
    setVisible: (s: boolean) => void,
    duration?: number;
    children: React.ReactNode;
    isControled: boolean;
}

const slideUp = keyframes`
    0% {
      opacity: 0;
      transform: translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  `;

const ToastContainer = styled.div`
    position: fixed;
    bottom: 70px;  // Высота от нижней части экрана
    left: 30px;
    transform: translateX(-50%);
    background-color: white;
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    opacity: 0;
    animation: ${slideUp} 0.5s forwards;
    z-index: 9999;
  `;